export default {
    key: 'first-glider',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    activityId: '6989ebdb-0d99-4630-9f05-a16b9bdfd397',
    categoryId: undefined,
    defaultDuration: 1440,
    isMultiDay: false,
    isUsingReductionCards: false,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    showDuration: false,
    upsells: [],
    salesTimeLimit: 660, // 11:00
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: '6989ebdb-0d99-4630-9f05-a16b9bdfd397',
    contentfulId: 'first-glider',
    steps: [],
} satisfies ProductConfigActivity;
